import { render, staticRenderFns } from "./UserBatch.vue?vue&type=template&id=5faadd6f"
import script from "./UserBatch.vue?vue&type=script&lang=js"
export * from "./UserBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports